export const WORK_STRUCTURE_TYPE = "עבודה" as const;
export const WORKS_PATH = "/works";
export const WORKS_BREADCRUMB = { ledger: "כרטסות", list: "קודי עבודה" } as const;
export const WORKS_STRUCTURE_CRUMBS = {
  search: "הגדרת מבנה חיפוש",
  browse: "הגדרת מבנה דפדוף",
} as const;
export const SEARCH_TABLE_STYLE = {
  backgroundColor: "rgb(35, 48, 68)",
  padding: 5,
  marginButton: 20,
} as const;
